import { useState } from 'react'
import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import { resolveThumbSrc } from '@aytm/app/stats/page/question-views/components/lib/utils'

// components
import BlockWrapper from '@aytm/app/stats/page/question-views/components/BlockWrapper'
import { pressable } from '@aytm/app/stats/components/lib/pressable'

// styles
import style from '@aytm/app/stats/page/question-views/vo/styles/Block.module.scss'

const Block = ({ id, link, video, answer, isSurveyGuest, isReportXpert }) => {
  const [showVideo, setShowVideo] = useState(false)

  const thumbSrc = resolveThumbSrc(video)

  return (
    <BlockWrapper {...{ id, link, answer, isSurveyGuest, isReportXpert }}>
      {video != undefined ? (
        <div className={style.video} style={{ '--video-ratio': video.ratio || 0.5 }}>
          {showVideo ? (
            <video
              id={`html5_id-${id}`}
              className={style.player}
              poster={thumbSrc}
              preload="auto"
              controls
              autoPlay
              controlsList="nodownload"
            >
              <source src={video.mp4File} type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"' />
            </video>
          ) : (
            <div className={style['video-thumbnail']} aria-label="Play video" {...pressable(() => setShowVideo(true))}>
              <img className={style.player} src={thumbSrc} alt="" />
              <img className={style['video-thumbnail-playback']} src="/images/ico/video-playback.png" alt="" />
            </div>
          )}
        </div>
      ) : (
        <div className={style.video}>
          <img src="/images/external_survey/missing_video.png" alt="" />
        </div>
      )}
    </BlockWrapper>
  )
}

Block.displayName = 'Block'

Block.propTypes = {
  id: PropTypes.string,
  answer: answerPropType,
  link: PropTypes.string,
  video: PropTypes.object,
  isReportXpert: PropTypes.bool,
  isSurveyGuest: PropTypes.bool
}

export default Block
